// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design-system fonts (SCO-387): Bebas Neue (display) + DM Sans (body), matching
   Jonathan's prototype. Loaded here — not in the PHP-rendered <head> — so it rides
   the bundled tailwind.css that every entry imports (style-loader injects it). Must
   precede @tailwind: a CSS @import after other rules is ignored by the browser. */

*, ::before, ::after{
		--tw-border-spacing-x: 0;
		--tw-border-spacing-y: 0;
		--tw-translate-x: 0;
		--tw-translate-y: 0;
		--tw-rotate: 0;
		--tw-skew-x: 0;
		--tw-skew-y: 0;
		--tw-scale-x: 1;
		--tw-scale-y: 1;
		--tw-pan-x:  ;
		--tw-pan-y:  ;
		--tw-pinch-zoom:  ;
		--tw-scroll-snap-strictness: proximity;
		--tw-gradient-from-position:  ;
		--tw-gradient-via-position:  ;
		--tw-gradient-to-position:  ;
		--tw-ordinal:  ;
		--tw-slashed-zero:  ;
		--tw-numeric-figure:  ;
		--tw-numeric-spacing:  ;
		--tw-numeric-fraction:  ;
		--tw-ring-inset:  ;
		--tw-ring-offset-width: 0px;
		--tw-ring-offset-color: #fff;
		--tw-ring-color: rgba(59, 130, 246, 0.5);
		--tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
		--tw-ring-shadow: 0 0 rgba(0,0,0,0);
		--tw-shadow: 0 0 rgba(0,0,0,0);
		--tw-shadow-colored: 0 0 rgba(0,0,0,0);
		--tw-blur:  ;
		--tw-brightness:  ;
		--tw-contrast:  ;
		--tw-grayscale:  ;
		--tw-hue-rotate:  ;
		--tw-invert:  ;
		--tw-saturate:  ;
		--tw-sepia:  ;
		--tw-drop-shadow:  ;
		--tw-backdrop-blur:  ;
		--tw-backdrop-brightness:  ;
		--tw-backdrop-contrast:  ;
		--tw-backdrop-grayscale:  ;
		--tw-backdrop-hue-rotate:  ;
		--tw-backdrop-invert:  ;
		--tw-backdrop-opacity:  ;
		--tw-backdrop-saturate:  ;
		--tw-backdrop-sepia:  ;
		--tw-contain-size:  ;
		--tw-contain-layout:  ;
		--tw-contain-paint:  ;
		--tw-contain-style:  ;
}

::backdrop{
		--tw-border-spacing-x: 0;
		--tw-border-spacing-y: 0;
		--tw-translate-x: 0;
		--tw-translate-y: 0;
		--tw-rotate: 0;
		--tw-skew-x: 0;
		--tw-skew-y: 0;
		--tw-scale-x: 1;
		--tw-scale-y: 1;
		--tw-pan-x:  ;
		--tw-pan-y:  ;
		--tw-pinch-zoom:  ;
		--tw-scroll-snap-strictness: proximity;
		--tw-gradient-from-position:  ;
		--tw-gradient-via-position:  ;
		--tw-gradient-to-position:  ;
		--tw-ordinal:  ;
		--tw-slashed-zero:  ;
		--tw-numeric-figure:  ;
		--tw-numeric-spacing:  ;
		--tw-numeric-fraction:  ;
		--tw-ring-inset:  ;
		--tw-ring-offset-width: 0px;
		--tw-ring-offset-color: #fff;
		--tw-ring-color: rgba(59, 130, 246, 0.5);
		--tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
		--tw-ring-shadow: 0 0 rgba(0,0,0,0);
		--tw-shadow: 0 0 rgba(0,0,0,0);
		--tw-shadow-colored: 0 0 rgba(0,0,0,0);
		--tw-blur:  ;
		--tw-brightness:  ;
		--tw-contrast:  ;
		--tw-grayscale:  ;
		--tw-hue-rotate:  ;
		--tw-invert:  ;
		--tw-saturate:  ;
		--tw-sepia:  ;
		--tw-drop-shadow:  ;
		--tw-backdrop-blur:  ;
		--tw-backdrop-brightness:  ;
		--tw-backdrop-contrast:  ;
		--tw-backdrop-grayscale:  ;
		--tw-backdrop-hue-rotate:  ;
		--tw-backdrop-invert:  ;
		--tw-backdrop-opacity:  ;
		--tw-backdrop-saturate:  ;
		--tw-backdrop-sepia:  ;
		--tw-contain-size:  ;
		--tw-contain-layout:  ;
		--tw-contain-paint:  ;
		--tw-contain-style:  ;
}
	:root {
		--background: 0 0% 100%;
		--foreground: 213 45% 14%;
		--card: 0 0% 100%;
		--card-foreground: 213 45% 14%;
		--popover: 0 0% 100%;
		--popover-foreground: 213 45% 14%;
		/* SBB Coral (prototype primary #E54E53). Was 358 85% 52% (legacy red). */
		--primary: 358 74% 60%;
		--primary-foreground: 0 0% 100%;
		--secondary: 213 48% 95%;
		--secondary-foreground: 213 45% 14%;
		--muted: 213 48% 95%;
		--muted-foreground: 213 15% 54%;
		--accent: 213 48% 95%;
		--accent-foreground: 213 45% 14%;
		--destructive: 358 85% 52%;
		--destructive-foreground: 0 0% 100%;
		--border: 0 0% 93%;
		--input: 0 0% 93%;
		--ring: 358 74% 60%;
		--radius: 0.5rem;

		--sidebar-background: 0 0% 100%;
		--sidebar-foreground: 213 15% 54%;
		--sidebar-primary: 358 74% 60%;
		--sidebar-primary-foreground: 0 0% 100%;
		--sidebar-accent: 0 0% 96%;
		--sidebar-accent-foreground: 213 45% 14%;
		--sidebar-border: 0 0% 93%;
		--sidebar-ring: 358 74% 60%;
	}
	*,
	::before,
	::after {
		box-sizing: border-box;
		border-width: 0;
		border-style: solid;
		border-color: hsl(var(--border));
	}
.container{
		width: 100%;
}
@media (min-width: 640px){

		.container{
				max-width: 640px;
		}
}
@media (min-width: 768px){

		.container{
				max-width: 768px;
		}
}
@media (min-width: 1024px){

		.container{
				max-width: 1024px;
		}
}
@media (min-width: 1280px){

		.container{
				max-width: 1280px;
		}
}
@media (min-width: 1536px){

		.container{
				max-width: 1536px;
		}
}
.sr-only{
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		white-space: nowrap;
		border-width: 0;
}
.pointer-events-none{
		pointer-events: none;
}
.visible{
		visibility: visible;
}
.invisible{
		visibility: hidden;
}
.static{
		position: static;
}
.fixed{
		position: fixed;
}
.absolute{
		position: absolute;
}
.relative{
		position: relative;
}
.inset-0{
		top: 0px;
		right: 0px;
		bottom: 0px;
		left: 0px;
}
.inset-x-0{
		left: 0px;
		right: 0px;
}
.inset-x-2{
		left: 0.5rem;
		right: 0.5rem;
}
.inset-y-0{
		top: 0px;
		bottom: 0px;
}
.-right-0\\.5{
		right: -0.125rem;
}
.-top-0\\.5{
		top: -0.125rem;
}
.bottom-0{
		bottom: 0px;
}
.left-0{
		left: 0px;
}
.left-2{
		left: 0.5rem;
}
.right-0{
		right: 0px;
}
.right-1{
		right: 0.25rem;
}
.right-2{
		right: 0.5rem;
}
.right-3{
		right: 0.75rem;
}
.right-4{
		right: 1rem;
}
.top-0{
		top: 0px;
}
.top-1\\.5{
		top: 0.375rem;
}
.top-3\\.5{
		top: 0.875rem;
}
.top-4{
		top: 1rem;
}
.top-\\[62px\\]{
		top: 62px;
}
.top-\\[var\\(--header-height\\2c 0px\\)\\]{
		top: 0px;
		top: var(--header-height,0px);
}
.top-\\[var\\(--header-height\\2c 54px\\)\\]{
		top: 54px;
		top: var(--header-height,54px);
}
.z-10{
		z-index: 10;
}
.z-20{
		z-index: 20;
}
.z-40{
		z-index: 40;
}
.z-50{
		z-index: 50;
}
.z-\\[1000000\\]{
		z-index: 1000000;
}
.z-\\[100\\]{
		z-index: 100;
}
.m-0{
		margin: 0px;
}
.-mx-1{
		margin-left: -0.25rem;
		margin-right: -0.25rem;
}
.-mx-4{
		margin-left: -1rem;
		margin-right: -1rem;
}
.mx-2{
		margin-left: 0.5rem;
		margin-right: 0.5rem;
}
.mx-3\\.5{
		margin-left: 0.875rem;
		margin-right: 0.875rem;
}
.mx-auto{
		margin-left: auto;
		margin-right: auto;
}
.my-1{
		margin-top: 0.25rem;
		margin-bottom: 0.25rem;
}
.mb-16{
		margin-bottom: 4rem;
}
.mb-2{
		margin-bottom: 0.5rem;
}
.mb-3{
		margin-bottom: 0.75rem;
}
.mb-4{
		margin-bottom: 1rem;
}
.mb-6{
		margin-bottom: 1.5rem;
}
.ml-1{
		margin-left: 0.25rem;
}
.ml-2{
		margin-left: 0.5rem;
}
.ml-3{
		margin-left: 0.75rem;
}
.ml-auto{
		margin-left: auto;
}
.mr-1{
		margin-right: 0.25rem;
}
.mr-2{
		margin-right: 0.5rem;
}
.mt-0\\.5{
		margin-top: 0.125rem;
}
.mt-1{
		margin-top: 0.25rem;
}
.mt-10{
		margin-top: 2.5rem;
}
.mt-12{
		margin-top: 3rem;
}
.mt-2{
		margin-top: 0.5rem;
}
.mt-3{
		margin-top: 0.75rem;
}
.mt-4{
		margin-top: 1rem;
}
.mt-5{
		margin-top: 1.25rem;
}
.mt-6{
		margin-top: 1.5rem;
}
.mt-8{
		margin-top: 2rem;
}
.block{
		display: block;
}
.inline-block{
		display: inline-block;
}
.inline{
		display: inline;
}
.flex{
		display: flex;
}
.inline-flex{
		display: inline-flex;
}
.table{
		display: table;
}
.grid{
		display: grid;
}
.hidden{
		display: none;
}
.aspect-square{
		aspect-ratio: 1 / 1;
}
.size-4{
		width: 1rem;
		height: 1rem;
}
.h-10{
		height: 2.5rem;
}
.h-12{
		height: 3rem;
}
.h-2{
		height: 0.5rem;
}
.h-24{
		height: 6rem;
}
.h-3{
		height: 0.75rem;
}
.h-3\\.5{
		height: 0.875rem;
}
.h-4{
		height: 1rem;
}
.h-5{
		height: 1.25rem;
}
.h-7{
		height: 1.75rem;
}
.h-8{
		height: 2rem;
}
.h-9{
		height: 2.25rem;
}
.h-\\[1px\\]{
		height: 1px;
}
.h-\\[400px\\]{
		height: 400px;
}
.h-\\[54px\\]{
		height: 54px;
}
.h-\\[calc\\(100svh-var\\(--header-height\\2c 0px\\)\\)\\]{
		height: calc(100svh - 0px);
		height: calc(100svh - var(--header-height,0px));
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
		height: var(--radix-select-trigger-height);
}
.h-full{
		height: 100%;
}
.h-px{
		height: 1px;
}
.h-svh{
		height: 100svh;
}
.max-h-96{
		max-height: 24rem;
}
.max-h-\\[70vh\\]{
		max-height: 70vh;
}
.min-h-0{
		min-height: 0px;
}
.min-h-full{
		min-height: 100%;
}
.min-h-svh{
		min-height: 100svh;
}
.w-10{
		width: 2.5rem;
}
.w-12{
		width: 3rem;
}
.w-2{
		width: 0.5rem;
}
.w-24{
		width: 6rem;
}
.w-3{
		width: 0.75rem;
}
.w-3\\.5{
		width: 0.875rem;
}
.w-3\\/4{
		width: 75%;
}
.w-36{
		width: 9rem;
}
.w-4{
		width: 1rem;
}
.w-40{
		width: 10rem;
}
.w-5{
		width: 1.25rem;
}
.w-56{
		width: 14rem;
}
.w-7{
		width: 1.75rem;
}
.w-72{
		width: 18rem;
}
.w-8{
		width: 2rem;
}
.w-80{
		width: 20rem;
}
.w-9{
		width: 2.25rem;
}
.w-\\[--sidebar-width\\]{
		width: var(--sidebar-width);
}
.w-\\[1px\\]{
		width: 1px;
}
.w-auto{
		width: auto;
}
.w-fit{
		width: fit-content;
}
.w-full{
		width: 100%;
}
.min-w-0{
		min-width: 0px;
}
.min-w-4{
		min-width: 1rem;
}
.min-w-5{
		min-width: 1.25rem;
}
.min-w-\\[8rem\\]{
		min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
		min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
		max-width: 40rem;
}
.max-w-4xl{
		max-width: 56rem;
}
.max-w-5xl{
		max-width: 64rem;
}
.max-w-\\[--skeleton-width\\]{
		max-width: var(--skeleton-width);
}
.max-w-\\[90vw\\]{
		max-width: 90vw;
}
.max-w-md{
		max-width: 28rem;
}
.flex-1{
		flex: 1 1 0%;
}
.flex-auto{
		flex: 1 1 auto;
}
.flex-none{
		flex: none;
}
.shrink-0{
		flex-shrink: 0;
}
.-translate-x-1\\/2{
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-px{
		--tw-translate-x: -1px;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-px{
		--tw-translate-x: 1px;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

		50%{
				opacity: .5;
		}
}
.animate-pulse{
		animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

		to{
				transform: rotate(360deg);
		}
}
.animate-spin{
		animation: spin 1s linear infinite;
}
.cursor-default{
		cursor: default;
}
.cursor-pointer{
		cursor: pointer;
}
.select-none{
		-webkit-user-select: none;
		        user-select: none;
}
.list-inside{
		list-style-position: inside;
}
.list-disc{
		list-style-type: disc;
}
.list-none{
		list-style-type: none;
}
.appearance-none{
		appearance: none;
}
.grid-cols-1{
		grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-col{
		flex-direction: column;
}
.flex-col-reverse{
		flex-direction: column-reverse;
}
.flex-wrap{
		flex-wrap: wrap;
}
.items-start{
		align-items: flex-start;
}
.items-center{
		align-items: center;
}
.justify-end{
		justify-content: flex-end;
}
.justify-center{
		justify-content: center;
}
.justify-between{
		justify-content: space-between;
}
.gap-0\\.5{
		gap: 0.125rem;
}
.gap-1{
		gap: 0.25rem;
}
.gap-2{
		gap: 0.5rem;
}
.gap-3{
		gap: 0.75rem;
}
.gap-4{
		gap: 1rem;
}
.gap-6{
		gap: 1.5rem;
}
.gap-x-4{
		column-gap: 1rem;
}
.gap-y-2{
		row-gap: 0.5rem;
}
.gap-y-8{
		row-gap: 2rem;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
		--tw-space-y-reverse: 0;
		margin-top: calc(0.25rem * (1 - var(--tw-space-y-reverse)));
		margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
		--tw-space-y-reverse: 0;
		margin-top: calc(0.375rem * (1 - var(--tw-space-y-reverse)));
		margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
		--tw-space-y-reverse: 0;
		margin-top: calc(0.5rem * (1 - var(--tw-space-y-reverse)));
		margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
		--tw-space-y-reverse: 0;
		margin-top: calc(0.75rem * (1 - var(--tw-space-y-reverse)));
		margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
		--tw-space-y-reverse: 0;
		margin-top: calc(1rem * (1 - var(--tw-space-y-reverse)));
		margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
		--tw-space-y-reverse: 0;
		margin-top: calc(1.5rem * (1 - var(--tw-space-y-reverse)));
		margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.self-center{
		align-self: center;
}
.overflow-auto{
		overflow: auto;
}
.overflow-hidden{
		overflow: hidden;
}
.overflow-x-auto{
		overflow-x: auto;
}
.overflow-y-auto{
		overflow-y: auto;
}
.scroll-smooth{
		scroll-behavior: smooth;
}
.truncate{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
}
.whitespace-nowrap{
		white-space: nowrap;
}
.break-all{
		word-break: break-all;
}
.rounded{
		border-radius: 0.25rem;
}
.rounded-base{
		border-radius: .3125rem;
}
.rounded-full{
		border-radius: 9999px;
}
.rounded-lg{
		border-radius: .781rem;
}
.rounded-md{
		border-radius: 0.375rem;
}
.rounded-sm{
		border-radius: .15rem;
}
.rounded-xl{
		border-radius: .935rem;
}
.border{
		border-width: 1px;
}
.border-0{
		border-width: 0px;
}
.border-2{
		border-width: 2px;
}
.border-b{
		border-bottom-width: 1px;
}
.border-l{
		border-left-width: 1px;
}
.border-l-4{
		border-left-width: 4px;
}
.border-r{
		border-right-width: 1px;
}
.border-t{
		border-top-width: 1px;
}
.border-dashed{
		border-style: dashed;
}
.border-blue-200{
		--tw-border-opacity: 1;
		border-color: rgba(191, 219, 254, 1);
		border-color: rgba(191, 219, 254, var(--tw-border-opacity, 1));
}
.border-border{
		border-color: hsl(var(--border));
}
.border-gray-200{
		--tw-border-opacity: 1;
		border-color: rgba(229, 231, 235, 1);
		border-color: rgba(229, 231, 235, var(--tw-border-opacity, 1));
}
.border-gray-300{
		--tw-border-opacity: 1;
		border-color: rgba(209, 213, 219, 1);
		border-color: rgba(209, 213, 219, var(--tw-border-opacity, 1));
}
.border-input{
		border-color: hsl(var(--input));
}
.border-primary{
		border-color: hsl(var(--primary));
}
.border-purple-200{
		--tw-border-opacity: 1;
		border-color: rgba(233, 213, 255, 1);
		border-color: rgba(233, 213, 255, var(--tw-border-opacity, 1));
}
.border-sidebar-border{
		border-color: hsl(var(--sidebar-border));
}
.border-transparent{
		border-color: transparent;
}
.border-l-red{
		--tw-border-opacity: 1;
		border-left-color: rgba(229, 78, 83, 1);
		border-left-color: rgba(229, 78, 83, var(--tw-border-opacity, 1));
}
.bg-background{
		background-color: hsl(var(--background));
}
.bg-black\\/80{
		background-color: rgba(0, 0, 0, 0.8);
}
.bg-black\\/\\[0\\.02\\]{
		background-color: rgba(0, 0, 0, 0.02);
}
.bg-blue-50{
		--tw-bg-opacity: 1;
		background-color: rgba(239, 246, 255, 1);
		background-color: rgba(239, 246, 255, var(--tw-bg-opacity, 1));
}
.bg-blue-600{
		--tw-bg-opacity: 1;
		background-color: rgba(37, 99, 235, 1);
		background-color: rgba(37, 99, 235, var(--tw-bg-opacity, 1));
}
.bg-border{
		background-color: hsl(var(--border));
}
.bg-card{
		background-color: hsl(var(--card));
}
.bg-current{
		background-color: currentColor;
}
.bg-dark-slate{
		--tw-bg-opacity: 1;
		background-color: rgba(19, 33, 50, 1);
		background-color: rgba(19, 33, 50, var(--tw-bg-opacity, 1));
}
.bg-destructive{
		background-color: hsl(var(--destructive));
}
.bg-gray-100{
		--tw-bg-opacity: 1;
		background-color: rgba(243, 244, 246, 1);
		background-color: rgba(243, 244, 246, var(--tw-bg-opacity, 1));
}
.bg-gray-50{
		--tw-bg-opacity: 1;
		background-color: rgba(249, 250, 251, 1);
		background-color: rgba(249, 250, 251, var(--tw-bg-opacity, 1));
}
.bg-gray-800{
		--tw-bg-opacity: 1;
		background-color: rgba(31, 41, 55, 1);
		background-color: rgba(31, 41, 55, var(--tw-bg-opacity, 1));
}
.bg-light-slate{
		--tw-bg-opacity: 1;
		background-color: rgba(238, 243, 249, 1);
		background-color: rgba(238, 243, 249, var(--tw-bg-opacity, 1));
}
.bg-medium-slate{
		--tw-bg-opacity: 1;
		background-color: rgba(42, 54, 70, 1);
		background-color: rgba(42, 54, 70, var(--tw-bg-opacity, 1));
}
.bg-muted{
		background-color: hsl(var(--muted));
}
.bg-popover{
		background-color: hsl(var(--popover));
}
.bg-primary{
		background-color: hsl(var(--primary));
}
.bg-primary\\/10{
		background-color: hsl(var(--primary) / 0.1);
}
.bg-red{
		--tw-bg-opacity: 1;
		background-color: rgba(229, 78, 83, 1);
		background-color: rgba(229, 78, 83, var(--tw-bg-opacity, 1));
}
.bg-secondary{
		background-color: hsl(var(--secondary));
}
.bg-sidebar{
		background-color: hsl(var(--sidebar-background));
}
.bg-sidebar-border{
		background-color: hsl(var(--sidebar-border));
}
.bg-transparent{
		background-color: transparent;
}
.bg-white{
		--tw-bg-opacity: 1;
		background-color: rgba(255, 255, 255, 1);
		background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}
.bg-gradient-to-r{
		background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-purple-50{
		--tw-gradient-from: #faf5ff var(--tw-gradient-from-position);
		--tw-gradient-to: rgba(250, 245, 255, 0) var(--tw-gradient-to-position);
		--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600{
		--tw-gradient-from: #9333ea var(--tw-gradient-from-position);
		--tw-gradient-to: rgba(147, 51, 234, 0) var(--tw-gradient-to-position);
		--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-700{
		--tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
		--tw-gradient-to: rgba(126, 34, 206, 0) var(--tw-gradient-to-position);
		--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-indigo-50{
		--tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
.to-indigo-600{
		--tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-indigo-700{
		--tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}
.fill-current{
		fill: currentColor;
}
.object-cover{
		object-fit: cover;
}
.p-0{
		padding: 0px;
}
.p-1{
		padding: 0.25rem;
}
.p-2{
		padding: 0.5rem;
}
.p-3{
		padding: 0.75rem;
}
.p-4{
		padding: 1rem;
}
.p-6{
		padding: 1.5rem;
}
.px-1{
		padding-left: 0.25rem;
		padding-right: 0.25rem;
}
.px-1\\.5{
		padding-left: 0.375rem;
		padding-right: 0.375rem;
}
.px-2{
		padding-left: 0.5rem;
		padding-right: 0.5rem;
}
.px-2\\.5{
		padding-left: 0.625rem;
		padding-right: 0.625rem;
}
.px-3{
		padding-left: 0.75rem;
		padding-right: 0.75rem;
}
.px-3\\.5{
		padding-left: 0.875rem;
		padding-right: 0.875rem;
}
.px-4{
		padding-left: 1rem;
		padding-right: 1rem;
}
.px-6{
		padding-left: 1.5rem;
		padding-right: 1.5rem;
}
.px-8{
		padding-left: 2rem;
		padding-right: 2rem;
}
.py-0\\.5{
		padding-top: 0.125rem;
		padding-bottom: 0.125rem;
}
.py-1{
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
}
.py-1\\.5{
		padding-top: 0.375rem;
		padding-bottom: 0.375rem;
}
.py-10{
		padding-top: 2.5rem;
		padding-bottom: 2.5rem;
}
.py-2{
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
}
.py-3{
		padding-top: 0.75rem;
		padding-bottom: 0.75rem;
}
.py-4{
		padding-top: 1rem;
		padding-bottom: 1rem;
}
.py-8{
		padding-top: 2rem;
		padding-bottom: 2rem;
}
.pl-2{
		padding-left: 0.5rem;
}
.pl-8{
		padding-left: 2rem;
}
.pr-2{
		padding-right: 0.5rem;
}
.pr-4{
		padding-right: 1rem;
}
.pr-8{
		padding-right: 2rem;
}
.pt-0{
		padding-top: 0px;
}
.pt-2{
		padding-top: 0.5rem;
}
.pt-4{
		padding-top: 1rem;
}
.text-left{
		text-align: left;
}
.text-center{
		text-align: center;
}
.text-right{
		text-align: right;
}
.align-middle{
		vertical-align: middle;
}
.font-display{
		font-family: Bebas Neue, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.font-mono{
		font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans{
		font-family: DM Sans, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl{
		font-size: 1.5rem;
		line-height: 2rem;
}
.text-3xl{
		font-size: 2rem;
		line-height: 2.5rem;
}
.text-\\[10px\\]{
		font-size: 10px;
}
.text-\\[11px\\]{
		font-size: 11px;
}
.text-\\[8px\\]{
		font-size: 8px;
}
.text-base{
		font-size: 1rem;
		line-height: 1.25;
}
.text-lg{
		font-size: 1.125rem;
		line-height: 2rem;
}
.text-sm{
		font-size: 0.875rem;
		line-height: 1.5rem;
}
.text-xl{
		font-size: 1.25rem;
		line-height: 2rem;
}
.text-xs{
		font-size: 0.75rem;
		line-height: 1rem;
}
.font-bold{
		font-weight: 700;
}
.font-medium{
		font-weight: 500;
}
.font-semibold{
		font-weight: 600;
}
.uppercase{
		text-transform: uppercase;
}
.tabular-nums{
		--tw-numeric-spacing: tabular-nums;
		font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-6{
		line-height: 1.5rem;
}
.leading-none{
		line-height: 1;
}
.leading-snug{
		line-height: 1.375;
}
.leading-tight{
		line-height: 1.25;
}
.tracking-tight{
		letter-spacing: -0.025em;
}
.tracking-wider{
		letter-spacing: 0.05em;
}
.tracking-widest{
		letter-spacing: 0.1em;
}
.text-card-foreground{
		color: hsl(var(--card-foreground));
}
.text-destructive{
		color: hsl(var(--destructive));
}
.text-destructive-foreground{
		color: hsl(var(--destructive-foreground));
}
.text-foreground{
		color: hsl(var(--foreground));
}
.text-gray-400{
		--tw-text-opacity: 1;
		color: rgba(156, 163, 175, 1);
		color: rgba(156, 163, 175, var(--tw-text-opacity, 1));
}
.text-gray-500{
		--tw-text-opacity: 1;
		color: rgba(107, 114, 128, 1);
		color: rgba(107, 114, 128, var(--tw-text-opacity, 1));
}
.text-gray-600{
		--tw-text-opacity: 1;
		color: rgba(75, 85, 99, 1);
		color: rgba(75, 85, 99, var(--tw-text-opacity, 1));
}
.text-gray-700{
		--tw-text-opacity: 1;
		color: rgba(55, 65, 81, 1);
		color: rgba(55, 65, 81, var(--tw-text-opacity, 1));
}
.text-gray-900{
		--tw-text-opacity: 1;
		color: rgba(17, 24, 39, 1);
		color: rgba(17, 24, 39, var(--tw-text-opacity, 1));
}
.text-muted-foreground{
		color: hsl(var(--muted-foreground));
}
.text-popover-foreground{
		color: hsl(var(--popover-foreground));
}
.text-primary{
		color: hsl(var(--primary));
}
.text-primary-foreground{
		color: hsl(var(--primary-foreground));
}
.text-purple-800{
		--tw-text-opacity: 1;
		color: rgba(107, 33, 168, 1);
		color: rgba(107, 33, 168, var(--tw-text-opacity, 1));
}
.text-purple-900{
		--tw-text-opacity: 1;
		color: rgba(88, 28, 135, 1);
		color: rgba(88, 28, 135, var(--tw-text-opacity, 1));
}
.text-red{
		--tw-text-opacity: 1;
		color: rgba(229, 78, 83, 1);
		color: rgba(229, 78, 83, var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
		color: hsl(var(--secondary-foreground));
}
.text-sidebar-foreground{
		color: hsl(var(--sidebar-foreground));
}
.text-sidebar-foreground\\/70{
		color: hsl(var(--sidebar-foreground) / 0.7);
}
.text-slate{
		--tw-text-opacity: 1;
		color: rgba(119, 135, 154, 1);
		color: rgba(119, 135, 154, var(--tw-text-opacity, 1));
}
.text-white{
		--tw-text-opacity: 1;
		color: rgba(255, 255, 255, 1);
		color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}
.underline{
		text-decoration-line: underline;
}
.underline-offset-4{
		text-underline-offset: 4px;
}
.antialiased{
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
}
.placeholder-gray-400::placeholder{
		--tw-placeholder-opacity: 1;
		color: rgba(156, 163, 175, 1);
		color: rgba(156, 163, 175, var(--tw-placeholder-opacity, 1));
}
.opacity-25{
		opacity: 0.25;
}
.opacity-50{
		opacity: 0.5;
}
.opacity-60{
		opacity: 0.6;
}
.opacity-70{
		opacity: 0.7;
}
.opacity-75{
		opacity: 0.75;
}
.shadow{
		--tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
		--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-2xl{
		--tw-shadow: 0 2px 5px 0 rgba(19,33,50,0.1), 0 17px 42px 0 rgba(19,33,50,0.10);
		--tw-shadow-colored: 0 2px 5px 0 var(--tw-shadow-color), 0 17px 42px 0 var(--tw-shadow-color);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-border\\)\\)\\]{
		--tw-shadow: 0 0 0 1px hsl(var(--sidebar-border));
		--tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-button{
		--tw-shadow: 0 1px 3px 0 rgba(19,33,50,0.15), 0 3px 5px 0 rgba(19,33,50,0.10);
		--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 3px 5px 0 var(--tw-shadow-color);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-lg{
		--tw-shadow: 0 1px 3px 0 rgba(19,33,50,0.1), 0 12.5px 30px 0 rgba(19,33,50,0.10);
		--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 12.5px 30px 0 var(--tw-shadow-color);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-md{
		--tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-none{
		--tw-shadow: 0 0 rgba(0,0,0,0);
		--tw-shadow-colored: 0 0 rgba(0,0,0,0);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-sm{
		--tw-shadow: 0 1px 3px 0 rgba(19,33,50,0.15);
		--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-xl{
		--tw-shadow: 0 1px 3px 0 rgba(19,33,50,0.1), 0 15px 35px 0 rgba(19,33,50,0.10);
		--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 15px 35px 0 var(--tw-shadow-color);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-gray-900\\/10{
		--tw-shadow-color: rgba(17, 24, 39, 0.1);
		--tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
		outline: 2px solid transparent;
		outline-offset: 2px;
}
.outline{
		outline-style: solid;
}
.ring{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-0{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-2{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-red\\/40{
		--tw-ring-color: rgba(229, 78, 83, 0.4);
}
.ring-sidebar-ring{
		--tw-ring-color: hsl(var(--sidebar-ring));
}
.ring-offset-background{
		--tw-ring-offset-color: hsl(var(--background));
}
.blur{
		--tw-blur: blur(8px);
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
		--tw-invert: invert(100%);
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
		transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
		transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
		transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
}
.transition-\\[left\\2c right\\2c width\\]{
		transition-property: left,right,width;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
}
.transition-\\[margin\\2c opacity\\]{
		transition-property: margin,opacity;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
}
.transition-\\[width\\2c height\\2c padding\\]{
		transition-property: width,height,padding;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
}
.transition-\\[width\\]{
		transition-property: width;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
}
.transition-all{
		transition-property: all;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
}
.transition-colors{
		transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
}
.transition-opacity{
		transition-property: opacity;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
}
.transition-transform{
		transition-property: transform;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
}
.duration-200{
		transition-duration: 200ms;
}
.ease-in-out{
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
		transition-timing-function: linear;
}
@keyframes enter{

		from{
				opacity: 1;
				opacity: var(--tw-enter-opacity, 1);
				transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
				transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
		}
}
@keyframes exit{

		to{
				opacity: 1;
				opacity: var(--tw-exit-opacity, 1);
				transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
				transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
		}
}
.animate-in{
		animation-name: enter;
		animation-duration: 150ms;
		--tw-enter-opacity: initial;
		--tw-enter-scale: initial;
		--tw-enter-rotate: initial;
		--tw-enter-translate-x: initial;
		--tw-enter-translate-y: initial;
}
.fade-in-0{
		--tw-enter-opacity: 0;
}
.zoom-in-95{
		--tw-enter-scale: .95;
}
.duration-200{
		animation-duration: 200ms;
}
.ease-in-out{
		animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
		animation-timing-function: linear;
}
.running{
		animation-play-state: running;
}
.paused{
		animation-play-state: paused;
}
.\\[display\\:none\\]{
		display: none;
}
.\\[font-feature-settings\\:\\'ss01\\'\\]{
		font-feature-settings: 'ss01';
}

/*
 * Preflight-equivalent border reset for shadcn primitives. The project
 * runs Tailwind with \`preflight: false\` so legacy CSS can coexist; shadcn
 * components still need the \`border-*\` / \`box-sizing\` defaults preflight
 * normally provides. The bare \`*\` selector keeps specificity at zero, so
 * any legacy class- or element-level rule wins over it.
 */

.file\\:border-0::file-selector-button{
		border-width: 0px;
}

.file\\:bg-transparent::file-selector-button{
		background-color: transparent;
}

.file\\:text-sm::file-selector-button{
		font-size: 0.875rem;
		line-height: 1.5rem;
}

.file\\:font-medium::file-selector-button{
		font-weight: 500;
}

.placeholder\\:text-muted-foreground::placeholder{
		color: hsl(var(--muted-foreground));
}

.after\\:absolute::after{
		content: var(--tw-content);
		position: absolute;
}

.after\\:-inset-2::after{
		content: var(--tw-content);
		top: -0.5rem;
		right: -0.5rem;
		bottom: -0.5rem;
		left: -0.5rem;
}

.after\\:inset-y-0::after{
		content: var(--tw-content);
		top: 0px;
		bottom: 0px;
}

.after\\:left-1\\/2::after{
		content: var(--tw-content);
		left: 50%;
}

.after\\:w-\\[2px\\]::after{
		content: var(--tw-content);
		width: 2px;
}

.last\\:border-0:last-child{
		border-width: 0px;
}

.last\\:border-b-0:last-child{
		border-bottom-width: 0px;
}

.hover\\:border-gray-400:hover{
		--tw-border-opacity: 1;
		border-color: rgba(156, 163, 175, 1);
		border-color: rgba(156, 163, 175, var(--tw-border-opacity, 1));
}

.hover\\:bg-accent:hover{
		background-color: hsl(var(--accent));
}

.hover\\:bg-black\\/5:hover{
		background-color: rgba(0, 0, 0, 0.05);
}

.hover\\:bg-blue-500:hover{
		--tw-bg-opacity: 1;
		background-color: rgba(59, 130, 246, 1);
		background-color: rgba(59, 130, 246, var(--tw-bg-opacity, 1));
}

.hover\\:bg-destructive\\/80:hover{
		background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover{
		background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-gray-50:hover{
		--tw-bg-opacity: 1;
		background-color: rgba(249, 250, 251, 1);
		background-color: rgba(249, 250, 251, var(--tw-bg-opacity, 1));
}

.hover\\:bg-light-slate:hover{
		--tw-bg-opacity: 1;
		background-color: rgba(238, 243, 249, 1);
		background-color: rgba(238, 243, 249, var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary\\/80:hover{
		background-color: hsl(var(--primary) / 0.8);
}

.hover\\:bg-primary\\/90:hover{
		background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-secondary\\/80:hover{
		background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:bg-sidebar-accent:hover{
		background-color: hsl(var(--sidebar-accent));
}

.hover\\:bg-white\\/10:hover{
		background-color: rgba(255, 255, 255, 0.1);
}

.hover\\:text-accent-foreground:hover{
		color: hsl(var(--accent-foreground));
}

.hover\\:text-foreground:hover{
		color: hsl(var(--foreground));
}

.hover\\:text-sidebar-accent-foreground:hover{
		color: hsl(var(--sidebar-accent-foreground));
}

.hover\\:underline:hover{
		text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
		opacity: 1;
}

.hover\\:opacity-80:hover{
		opacity: 0.8;
}

.hover\\:opacity-90:hover{
		opacity: 0.9;
}

.hover\\:shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-accent\\)\\)\\]:hover{
		--tw-shadow: 0 0 0 1px hsl(var(--sidebar-accent));
		--tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.hover\\:after\\:bg-sidebar-border:hover::after{
		content: var(--tw-content);
		background-color: hsl(var(--sidebar-border));
}

.focus\\:border-blue-500:focus{
		--tw-border-opacity: 1;
		border-color: rgba(59, 130, 246, 1);
		border-color: rgba(59, 130, 246, var(--tw-border-opacity, 1));
}

.focus\\:bg-accent:focus{
		background-color: hsl(var(--accent));
}

.focus\\:bg-white:focus{
		--tw-bg-opacity: 1;
		background-color: rgba(255, 255, 255, 1);
		background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}

.focus\\:text-accent-foreground:focus{
		color: hsl(var(--accent-foreground));
}

.focus\\:outline-none:focus{
		outline: 2px solid transparent;
		outline-offset: 2px;
}

.focus\\:ring-1:focus{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus\\:ring-2:focus{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus\\:ring-blue-500:focus{
		--tw-ring-opacity: 1;
		--tw-ring-color: rgba(59, 130, 246, var(--tw-ring-opacity, 1));
}

.focus\\:ring-ring:focus{
		--tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-offset-2:focus{
		--tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none.focus-visible{
		outline: 2px solid transparent;
		outline-offset: 2px;
}

.focus-visible\\:outline-none:focus-visible{
		outline: 2px solid transparent;
		outline-offset: 2px;
}

.focus-visible\\:outline.focus-visible{
		outline-style: solid;
}

.focus-visible\\:outline:focus-visible{
		outline-style: solid;
}

.focus-visible\\:outline-2.focus-visible{
		outline-width: 2px;
}

.focus-visible\\:outline-2:focus-visible{
		outline-width: 2px;
}

.focus-visible\\:outline-offset-2.focus-visible{
		outline-offset: 2px;
}

.focus-visible\\:outline-offset-2:focus-visible{
		outline-offset: 2px;
}

.focus-visible\\:outline-gray-900.focus-visible{
		outline-color: #111827;
}

.focus-visible\\:outline-gray-900:focus-visible{
		outline-color: #111827;
}

.focus-visible\\:ring-1.focus-visible{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-visible\\:ring-1.focus-visible{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-visible\\:ring-1.focus-visible{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-visible\\:ring-1:focus-visible{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-visible\\:ring-2.focus-visible{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-visible\\:ring-2.focus-visible{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-visible\\:ring-2.focus-visible{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-visible\\:ring-2:focus-visible{
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-visible\\:ring-ring.focus-visible{
		--tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-ring:focus-visible{
		--tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-sidebar-ring.focus-visible{
		--tw-ring-color: hsl(var(--sidebar-ring));
}

.focus-visible\\:ring-sidebar-ring:focus-visible{
		--tw-ring-color: hsl(var(--sidebar-ring));
}

.focus-visible\\:ring-offset-2.focus-visible{
		--tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-2:focus-visible{
		--tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background.focus-visible{
		--tw-ring-offset-color: hsl(var(--background));
}

.focus-visible\\:ring-offset-background:focus-visible{
		--tw-ring-offset-color: hsl(var(--background));
}

.active\\:bg-sidebar-accent:active{
		background-color: hsl(var(--sidebar-accent));
}

.active\\:text-sidebar-accent-foreground:active{
		color: hsl(var(--sidebar-accent-foreground));
}

.disabled\\:pointer-events-none:disabled{
		pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
		cursor: not-allowed;
}

.disabled\\:opacity-50:disabled{
		opacity: 0.5;
}

.group\\/menu-item[focus-within] .group-focus-within\\/menu-item\\:opacity-100{
		opacity: 1;
}

.group\\/menu-item:focus-within .group-focus-within\\/menu-item\\:opacity-100{
		opacity: 1;
}

.group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100{
		opacity: 1;
}

.peer\\/menu-button:hover ~ .peer-hover\\/menu-button\\:text-sidebar-accent-foreground{
		color: hsl(var(--sidebar-accent-foreground));
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
		cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70{
		opacity: 0.7;
}

.has-\\[\\[data-variant\\=inset\\]\\]\\:bg-sidebar[\\:has\\(\\[data-variant\\%3Dinset\\]\\)]{
		background-color: hsl(var(--sidebar-background));
}

.has-\\[\\[data-variant\\=inset\\]\\]\\:bg-sidebar:has([data-variant=inset]){
		background-color: hsl(var(--sidebar-background));
}

.group\\/menu-item[\\:has\\(\\[data-sidebar\\%3Dmenu-action\\]\\)] .group-has-\\[\\[data-sidebar\\=menu-action\\]\\]\\/menu-item\\:pr-8{
		padding-right: 2rem;
}

.group\\/menu-item:has([data-sidebar=menu-action]) .group-has-\\[\\[data-sidebar\\=menu-action\\]\\]\\/menu-item\\:pr-8{
		padding-right: 2rem;
}

.aria-disabled\\:pointer-events-none[aria-disabled="true"]{
		pointer-events: none;
}

.aria-disabled\\:opacity-50[aria-disabled="true"]{
		opacity: 0.5;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
		pointer-events: none;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
		--tw-translate-y: 0.25rem;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
		--tw-translate-x: -0.25rem;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
		--tw-translate-x: 0.25rem;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
		--tw-translate-y: -0.25rem;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
		--tw-translate-x: 1rem;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
		--tw-translate-x: 0px;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[active\\=true\\]\\:bg-sidebar-accent[data-active="true"]{
		background-color: hsl(var(--sidebar-accent));
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
		background-color: hsl(var(--primary));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
		background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
		background-color: hsl(var(--secondary));
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
		background-color: hsl(var(--input));
}

.data-\\[active\\=true\\]\\:font-medium[data-active="true"]{
		font-weight: 500;
}

.data-\\[active\\=true\\]\\:text-sidebar-accent-foreground[data-active="true"]{
		color: hsl(var(--sidebar-accent-foreground));
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]{
		opacity: 0.5;
}

.data-\\[state\\=open\\]\\:opacity-100[data-state="open"]{
		opacity: 1;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
		transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
		transition-duration: 500ms;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
		animation-name: enter;
		animation-duration: 150ms;
		--tw-enter-opacity: initial;
		--tw-enter-scale: initial;
		--tw-enter-rotate: initial;
		--tw-enter-translate-x: initial;
		--tw-enter-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
		animation-name: exit;
		animation-duration: 150ms;
		--tw-exit-opacity: initial;
		--tw-exit-scale: initial;
		--tw-exit-rotate: initial;
		--tw-exit-translate-x: initial;
		--tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
		--tw-exit-opacity: 0;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
		--tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
		--tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
		--tw-enter-scale: .95;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
		--tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
		--tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
		--tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
		--tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
		--tw-exit-translate-y: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
		--tw-exit-translate-x: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
		--tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
		--tw-exit-translate-y: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
		--tw-enter-translate-y: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
		--tw-enter-translate-x: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
		--tw-enter-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
		--tw-enter-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
		animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
		animation-duration: 500ms;
}

.data-\\[state\\=open\\]\\:hover\\:bg-sidebar-accent:hover[data-state="open"]{
		background-color: hsl(var(--sidebar-accent));
}

.data-\\[state\\=open\\]\\:hover\\:text-sidebar-accent-foreground:hover[data-state="open"]{
		color: hsl(var(--sidebar-accent-foreground));
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:left-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\]{
		left: calc(var(--sidebar-width) * -1);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:right-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\]{
		right: calc(var(--sidebar-width) * -1);
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:-right-4{
		right: -1rem;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:left-0{
		left: 0px;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:-mt-8{
		margin-top: -2rem;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:hidden{
		display: none;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!size-8{
		width: 2rem !important;
		height: 2rem !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[--sidebar-width-icon\\]{
		width: var(--sidebar-width-icon);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)\\)\\]{
		width: calc(var(--sidebar-width-icon) + 1rem);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)_\\+2px\\)\\]{
		width: calc(var(--sidebar-width-icon) + 1rem + 2px);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:w-0{
		width: 0px;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:translate-x-0{
		--tw-translate-x: 0px;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:rotate-180{
		--tw-rotate: 180deg;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:overflow-hidden{
		overflow: hidden;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:rounded-lg{
		border-radius: .781rem;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border{
		border-width: 1px;
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:border-r{
		border-right-width: 1px;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:border-l{
		border-left-width: 1px;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border-sidebar-border{
		border-color: hsl(var(--sidebar-border));
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!p-0{
		padding: 0px !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!p-2{
		padding: 0.5rem !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:px-0{
		padding-left: 0px;
		padding-right: 0px;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:pr-2{
		padding-right: 0.5rem;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:opacity-0{
		opacity: 0;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:shadow{
		--tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
		--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
		box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:after\\:left-full::after{
		content: var(--tw-content);
		left: 100%;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:hover\\:bg-sidebar:hover{
		background-color: hsl(var(--sidebar-background));
}

.peer\\/menu-button[data-size="default"] ~ .peer-data-\\[size\\=default\\]\\/menu-button\\:top-1\\.5{
		top: 0.375rem;
}

.peer\\/menu-button[data-size="lg"] ~ .peer-data-\\[size\\=lg\\]\\/menu-button\\:top-2\\.5{
		top: 0.625rem;
}

.peer\\/menu-button[data-size="sm"] ~ .peer-data-\\[size\\=sm\\]\\/menu-button\\:top-1{
		top: 0.25rem;
}

.peer[data-variant="inset"] ~ .peer-data-\\[variant\\=inset\\]\\:h-\\[calc\\(100svh-theme\\(spacing\\.4\\)\\)\\]{
		height: calc(100svh - 1rem);
}

.peer\\/menu-button[data-active="true"] ~ .peer-data-\\[active\\=true\\]\\/menu-button\\:text-sidebar-accent-foreground{
		color: hsl(var(--sidebar-accent-foreground));
}

@media (prefers-reduced-motion: no-preference){

		.motion-safe\\:animate-in{
				animation-name: enter;
				animation-duration: 150ms;
				--tw-enter-opacity: initial;
				--tw-enter-scale: initial;
				--tw-enter-rotate: initial;
				--tw-enter-translate-x: initial;
				--tw-enter-translate-y: initial;
		}

		.motion-safe\\:fade-in-0{
				--tw-enter-opacity: 0;
		}

		.motion-safe\\:zoom-in-95{
				--tw-enter-scale: .95;
		}
}

@media (min-width: 640px){

		.sm\\:inset-x-4{
				left: 1rem;
				right: 1rem;
		}

		.sm\\:col-span-2{
				grid-column: span 2 / span 2;
		}

		.sm\\:mx-0{
				margin-left: 0px;
				margin-right: 0px;
		}

		.sm\\:ml-3{
				margin-left: 0.75rem;
		}

		.sm\\:mt-0{
				margin-top: 0px;
		}

		.sm\\:flex{
				display: flex;
		}

		.sm\\:contents{
				display: contents;
		}

		.sm\\:w-auto{
				width: auto;
		}

		.sm\\:max-w-sm{
				max-width: 24rem;
		}

		.sm\\:grid-cols-2{
				grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.sm\\:flex-row{
				flex-direction: row;
		}

		.sm\\:justify-end{
				justify-content: flex-end;
		}

		.sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
				--tw-space-x-reverse: 0;
				margin-right: calc(0.5rem * var(--tw-space-x-reverse));
				margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
				margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
		}

		.sm\\:rounded-xl{
				border-radius: .935rem;
		}

		.sm\\:px-10{
				padding-left: 2.5rem;
				padding-right: 2.5rem;
		}

		.sm\\:px-6{
				padding-left: 1.5rem;
				padding-right: 1.5rem;
		}

		.sm\\:py-12{
				padding-top: 3rem;
				padding-bottom: 3rem;
		}

		.sm\\:text-left{
				text-align: left;
		}

		.sm\\:text-sm{
				font-size: 0.875rem;
				line-height: 1.5rem;
		}
}

@media (min-width: 768px){

		.md\\:block{
				display: block;
		}

		.md\\:\\!flex{
				display: flex !important;
		}

		.md\\:flex{
				display: flex;
		}

		.md\\:hidden{
				display: none;
		}

		.md\\:w-1\\/4{
				width: 25%;
		}

		.md\\:min-w-0{
				min-width: 0px;
		}

		.md\\:flex-1{
				flex: 1 1 0%;
		}

		.md\\:shrink-0{
				flex-shrink: 0;
		}

		.md\\:grid-cols-2{
				grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.md\\:items-start{
				align-items: flex-start;
		}

		.md\\:gap-6{
				gap: 1.5rem;
		}

		.md\\:p-6{
				padding: 1.5rem;
		}

		.md\\:px-28{
				padding-left: 7rem;
				padding-right: 7rem;
		}

		.md\\:px-6{
				padding-left: 1.5rem;
				padding-right: 1.5rem;
		}

		.md\\:text-sm{
				font-size: 0.875rem;
				line-height: 1.5rem;
		}

		.md\\:opacity-0{
				opacity: 0;
		}

		.after\\:md\\:hidden::after{
				content: var(--tw-content);
				display: none;
		}

		.peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:m-2{
				margin: 0.5rem;
		}

		.peer[data-state="collapsed"][data-variant="inset"] ~ .md\\:peer-data-\\[state\\=collapsed\\]\\:peer-data-\\[variant\\=inset\\]\\:ml-2{
				margin-left: 0.5rem;
		}

		.peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:ml-0{
				margin-left: 0px;
		}

		.peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:rounded-xl{
				border-radius: .935rem;
		}

		.peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:shadow{
				--tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
				--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
				box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
				box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
		}
}

.\\[\\&\\>button\\]\\:hidden>button{
		display: none;
}

.\\[\\&\\>span\\:last-child\\]\\:truncate>span:last-child{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
}

.\\[\\&\\>span\\]\\:line-clamp-1>span{
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
}

.\\[\\&\\>svg\\]\\:size-4>svg{
		width: 1rem;
		height: 1rem;
}

.\\[\\&\\>svg\\]\\:shrink-0>svg{
		flex-shrink: 0;
}

.\\[\\&\\>svg\\]\\:text-sidebar-accent-foreground>svg{
		color: hsl(var(--sidebar-accent-foreground));
}

.\\[\\&\\>svg\\]\\:text-sidebar-foreground\\/60>svg{
		color: hsl(var(--sidebar-foreground) / 0.6);
}

.data-\\[active\\=true\\]\\:\\[\\&\\>svg\\]\\:\\!text-sidebar-primary>svg[data-active="true"]{
		color: hsl(var(--sidebar-primary)) !important;
}

.\\[\\&_li\\]\\:list-none li{
		list-style-type: none;
}

.\\[\\&_p\\]\\:m-0 p{
		margin: 0px;
}

.\\[\\&_svg\\]\\:pointer-events-none svg{
		pointer-events: none;
}

.\\[\\&_svg\\]\\:size-4 svg{
		width: 1rem;
		height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0 svg{
		flex-shrink: 0;
}

[data-side=left][data-collapsible=offcanvas] .\\[\\[data-side\\=left\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-right-2{
		right: -0.5rem;
}

[data-side=left][data-state=collapsed] .\\[\\[data-side\\=left\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-e-resize{
		cursor: e-resize;
}

[data-side=left] .\\[\\[data-side\\=left\\]_\\&\\]\\:cursor-w-resize{
		cursor: w-resize;
}

[data-side=right][data-collapsible=offcanvas] .\\[\\[data-side\\=right\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-left-2{
		left: -0.5rem;
}

[data-side=right][data-state=collapsed] .\\[\\[data-side\\=right\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-w-resize{
		cursor: w-resize;
}

[data-side=right] .\\[\\[data-side\\=right\\]_\\&\\]\\:cursor-e-resize{
		cursor: e-resize;
}
`, "",{"version":3,"sources":["webpack://./styles/tailwind.css"],"names":[],"mappings":"AAAA;;;kFAGkF;;AAGlF;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;CAAd;EAAA,uBAAc;EAAd,yBAAc;EAAd,iBAAc;EAAd,8BAAc;EAAd,oBAAc;EAAd,iCAAc;EAAd,yEAAc;EAAd,sBAAc;EAAd,+BAAc;EAAd,wBAAc;EAAd,mCAAc;EAAd,oBAAc;EAAd,+BAAc;EAAd,qBAAc;EAAd,gCAAc;EAAd,0BAAc;EAAd,mCAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,mBAAc;EAAd,gBAAc;;EAAd,+BAAc;EAAd,iCAAc;EAAd,8BAAc;EAAd,uCAAc;EAAd,0BAAc;EAAd,wCAAc;EAAd,0BAAc;EAAd,2BAAc;CAAA;CAAd;;;EAAA,sBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,gCAAc;CAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,0DAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,0DAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,8FAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,6FAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,qDAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,2FAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,+FAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB,iGAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,sCAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,6FAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB,mCAAmB;IAAnB,0DAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,UAAmB;IAAnB,kCAAmB;IAAnB,0DAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAqCnB;;;;;;EAME;;AAnDF;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,mBA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,0BA8DA;EA9DA;AA8DA;;AA9DA;EAAA,0BA8DA;EA9DA,YA8DA;EA9DA,cA8DA;EA9DA,eA8DA;EA9DA;AA8DA;;AA9DA;EAAA,0BA8DA;EA9DA,QA8DA;EA9DA;AA8DA;;AA9DA;EAAA,0BA8DA;EA9DA;AA8DA;;AA9DA;EAAA,0BA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,sBA8DA;EA9DA,oCA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,kBA8DA;EA9DA,uCA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,kBA8DA;EA9DA,wCA8DA;EA9DA;AA8DA;;AA9DA;EAAA,kBA8DA;EA9DA,wCA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,iDA8DA;EA9DA,qDA8DA;EA9DA,kEA8DA;EA9DA;AA8DA;;AA9DA;EAAA,0BA8DA;EA9DA;AA8DA;;AA9DA;EAAA,sBA8DA;EA9DA,mCA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,kBA8DA;EA9DA,wCA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,8BA8DA;EA9DA;AA8DA;;AA9DA;EAAA,2GA8DA;EA9DA,yGA8DA;EA9DA,kFA8DA;EA9DA;AA8DA;;AA9DA;EAAA,2GA8DA;EA9DA,yGA8DA;EA9DA,kFA8DA;EA9DA;AA8DA;;AA9DA;EAAA,oBA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,8BA8DA;EA9DA;AA8DA;;AA9DA;EAAA,8BA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,2GA8DA;EA9DA,yGA8DA;EA9DA,kFA8DA;EA9DA;AA8DA;;AA9DA;EAAA,2GA8DA;EA9DA,yGA8DA;EA9DA,kFA8DA;EA9DA;AA8DA;;AA9DA;EAAA,2GA8DA;EA9DA,yGA8DA;EA9DA,kFA8DA;EA9DA;AA8DA;;AA9DA;EAAA,2GA8DA;EA9DA,yGA8DA;EA9DA,kFA8DA;EA9DA;AA8DA;;AA9DA;EAAA,2GA8DA;EA9DA,yGA8DA;EA9DA,kFA8DA;EA9DA;AA8DA;;AA9DA;EAAA,2GA8DA;EA9DA,yGA8DA;EA9DA,kFA8DA;EA9DA;AA8DA;;AA9DA;EAAA,2GA8DA;EA9DA,yGA8DA;EA9DA,kFA8DA;EA9DA;AA8DA;;AA9DA;EAAA,2GA8DA;EA9DA,yGA8DA;EA9DA,kFA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,yBA8DA;EA9DA;AA8DA;;AA9DA;EAAA,0BA8DA;EA9DA;AA8DA;;AA9DA;EAAA,yBA8DA;EA9DA;AA8DA;;AA9DA;EAAA,0BA8DA;EA9DA;AA8DA;;AA9DA;EAAA,sBA8DA;EA9DA;AA8DA;;AA9DA;EAAA,qBA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,qBA8DA;EA9DA,yBA8DA;EA9DA,2BA8DA;EA9DA,yBA8DA;EA9DA,0BA8DA;EA9DA,+BA8DA;EA9DA;AA8DA;;AA9DA;EAAA,oBA8DA;EA9DA,yBA8DA;EA9DA,0BA8DA;EA9DA,wBA8DA;EA9DA,yBA8DA;EA9DA,8BA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,sBA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,qBA8DA;EA9DA;AA8DA;;AA9DA;EAAA,mBA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,iBA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,8EA8DA;EA9DA,8FA8DA;EA9DA,kEA8DA;EA9DA;AA8DA;;AA9DA;EAAA,0BA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;;EAAA;IAAA,qBA8DA;IA9DA,yBA8DA;IA9DA,2BA8DA;IA9DA,yBA8DA;IA9DA,0BA8DA;IA9DA,+BA8DA;IA9DA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;AAAA;;AA9DA;;EAAA;IAAA,UA8DA;IA9DA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA,gBA8DA;IA9DA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA,uBA8DA;IA9DA,sDA8DA;IA9DA,2DA8DA;IA9DA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA,oBA8DA;IA9DA;EA8DA;;EA9DA;IAAA,oBA8DA;IA9DA;EA8DA;;EA9DA;IAAA,iBA8DA;IA9DA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA,mBA8DA;IA9DA;EA8DA;AAAA;;AA9DA;;EAAA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA,kBA8DA;IA9DA;EA8DA;;EA9DA;IAAA,oBA8DA;IA9DA;EA8DA;;EA9DA;IAAA,mBA8DA;IA9DA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA,0BA8DA;IA9DA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA;EA8DA;;EA9DA;IAAA,8EA8DA;IA9DA,8FA8DA;IA9DA,kEA8DA;IA9DA;EA8DA;AAAA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,gBA8DA;EA9DA,uBA8DA;EA9DA;AA8DA;;AA9DA;EAAA,gBA8DA;EA9DA,oBA8DA;EA9DA,4BA8DA;EA9DA;AA8DA;;AA9DA;EAAA,WA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA,WA8DA;EA9DA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA;;AA9DA;EAAA;AA8DA","sourcesContent":["/* Design-system fonts (SCO-387): Bebas Neue (display) + DM Sans (body), matching\n   Jonathan's prototype. Loaded here — not in the PHP-rendered <head> — so it rides\n   the bundled tailwind.css that every entry imports (style-loader injects it). Must\n   precede @tailwind: a CSS @import after other rules is ignored by the browser. */\n@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@400;500;600;700&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n\t:root {\n\t\t--background: 0 0% 100%;\n\t\t--foreground: 213 45% 14%;\n\t\t--card: 0 0% 100%;\n\t\t--card-foreground: 213 45% 14%;\n\t\t--popover: 0 0% 100%;\n\t\t--popover-foreground: 213 45% 14%;\n\t\t/* SBB Coral (prototype primary #E54E53). Was 358 85% 52% (legacy red). */\n\t\t--primary: 358 74% 60%;\n\t\t--primary-foreground: 0 0% 100%;\n\t\t--secondary: 213 48% 95%;\n\t\t--secondary-foreground: 213 45% 14%;\n\t\t--muted: 213 48% 95%;\n\t\t--muted-foreground: 213 15% 54%;\n\t\t--accent: 213 48% 95%;\n\t\t--accent-foreground: 213 45% 14%;\n\t\t--destructive: 358 85% 52%;\n\t\t--destructive-foreground: 0 0% 100%;\n\t\t--border: 0 0% 93%;\n\t\t--input: 0 0% 93%;\n\t\t--ring: 358 74% 60%;\n\t\t--radius: 0.5rem;\n\n\t\t--sidebar-background: 0 0% 100%;\n\t\t--sidebar-foreground: 213 15% 54%;\n\t\t--sidebar-primary: 358 74% 60%;\n\t\t--sidebar-primary-foreground: 0 0% 100%;\n\t\t--sidebar-accent: 0 0% 96%;\n\t\t--sidebar-accent-foreground: 213 45% 14%;\n\t\t--sidebar-border: 0 0% 93%;\n\t\t--sidebar-ring: 358 74% 60%;\n\t}\n}\n\n/*\n * Preflight-equivalent border reset for shadcn primitives. The project\n * runs Tailwind with `preflight: false` so legacy CSS can coexist; shadcn\n * components still need the `border-*` / `box-sizing` defaults preflight\n * normally provides. The bare `*` selector keeps specificity at zero, so\n * any legacy class- or element-level rule wins over it.\n */\n@layer base {\n\t*,\n\t::before,\n\t::after {\n\t\tbox-sizing: border-box;\n\t\tborder-width: 0;\n\t\tborder-style: solid;\n\t\tborder-color: hsl(var(--border));\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
